// extracted by mini-css-extract-plugin
export default {"sort":"GU-z","sortSelect":"HU-z","disabled":"IU-z"};